import React, { useState, useEffect } from "react";

const DropboxPlayer = ({
  styleClass,
  customStyles,
  videoUrl,
  isVideoDetailPage,
}) => {
  const [poster, setPoster] = useState(true);

  const urlUpdate = {
    "www.dropbox.com": "dl.dropboxusercontent.com",
    "dl=0": "raw=1#t=3",
  };

  const dropboxUrl = videoUrl?.replace(
    /\b(?:www.dropbox.com|dl=0)\b/gi,
    (matched) => urlUpdate[matched]
  );

  useEffect(() => {
    let isMounted = true;
    const fetchDropboxUrl = async () => {
      try {
        const res = await fetch(dropboxUrl);
        const status = await res.status;
        if (isMounted && status === 404) {
          setPoster(false);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const timeoutId = setTimeout(() => {
      fetchDropboxUrl();
    }, 2000);

    return () => {
      clearTimeout(timeoutId);
      isMounted = false;
    };
  }, [videoUrl]);

  return (
    <video
      className={styleClass}
      style={{
        ...customStyles,
        ...(!poster &&
          isVideoDetailPage && { height: "291px", objectFit: "contain" }),
      }}
      width="100%"
      height="291px"
      poster={
        poster
          ? undefined
          : require("@src/assets/images/vyrill/dropbox-deleted.png").default
      }
    >
      <source src={dropboxUrl} />
    </video>
  );
};

export default React.memo(DropboxPlayer);
